module.exports = __webpack_public_path__ + "static/media/5 1 tattoo holy god roman black white.1280x1739.95513288.webp";